// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-download-button{\n    /* background-color: rgb(220,70,75);  */\n    background-color: darkred;\n    cursor: pointer; \n    border: chocolate; \n    color: white;\n    border-radius: 0px;\n    color: white;\n    font-size: 16px;\n    padding: 8px 20px;\n}\n\n.upload-download-button:hover{\n    /* background-color: grey; */\n    background-color: rgb(180, 19, 19);\n}\n\n#button-icon{\n    color : white;\n    padding: 0%;\n    font-size: 16px;\n}", ""]);
// Exports
module.exports = exports;
